import React from 'react'
import Button from './Button'
export default function PaymentStatus({statusData,open}) {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg w-96">
          <div>
            <h2 className="text-lg font-bold text-black-600 mb-4">
              💵 Payment Status
            </h2>
             <p className="mb-2"><strong>Order ID:</strong> {statusData.order_id}</p>
              <p className="mb-2"><strong>Txn Order ID:</strong> {statusData.payment_orderId}</p>
               <p className="mb-2"><strong>Txn Id:</strong> {statusData.txn_uuid}</p>
             <p className="mb-2"><strong>Payment Type:</strong> {statusData.paymentType }</p>
            <p className="mb-2">
                <strong>Amount:</strong>{" "}
                {statusData.amount
                  ? `${statusData.currency} ${statusData.amount}`
                  : statusData.total
                    }
              </p> 
              <p className="mb-2"><strong>Txn Date:</strong> {statusData.txnDate}</p>
              <p className="mb-2"><strong>Txn Status:</strong> {statusData.status}</p>
          </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={open}
          className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          Close
        </button>
      </div>
    </div>
  </div>
    )
}